import { API } from 'api';
import { useQuery } from 'react-query';

interface IGetPointsBalance {
  payload: {
    eid: string;
    ebid?: string;
  };
}
export const getPointsBalance = (payload: IGetPointsBalance['payload']) =>
  API.get()(`/api/admin/reward/balance?eid=${payload.eid}${payload?.ebid ? '&ebid='.concat(payload?.ebid) : ''}`);

export const usePointsBalance = (data: IGetPointsBalance['payload'], options: { enabled: boolean }) => {
  return useQuery(['point', data], () => getPointsBalance(data), {
    enabled: options?.enabled ?? true,
    select: (response: any) => response?.data?.data,
  });
};
